import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonComponent} from './components/button/button.component';
import {SliderComponent} from './components/slider/slider.component';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {TextInputComponent} from './components/text-input/text-input.component';
import {LabelComponent} from './components/label/label.component';
import {AdNetComponent} from './components/ad-net/ad-net.component';
import {CameraComponent} from './components/camera/camera.component';
import {CartComponent} from './components/cart/cart.component';
import {CatalogItemComponent} from './components/catalog-item/catalog-item.component';
import {CatalogPlayerComponent} from './components/catalog-player/catalog-player.component';
import {ChartComponent} from './components/chart/chart.component';
import {ClockComponent} from './components/clock/clock.component';
import {CollectionComponent} from './components/collection/collection.component';
import {CountdownComponent} from './components/countdown/countdown.component';
import {CustomRssItemComponent} from './components/custom-rss-item/custom-rss-item.component';
import {CustomRssPlayerComponent} from './components/custom-rss-player/custom-rss-player.component';
import {ExtAppComponent} from './components/ext-app/ext-app.component';
import {ExtImageComponent} from './components/ext-image/ext-image.component';
import {ExtVideoComponent} from './components/ext-video/ext-video.component';
import {FasterQComponent} from './components/faster-q/faster-q.component';
import {FormComponent} from './components/form/form.component';
import {HtmlComponent} from './components/html/html.component';
import {ImageComponent} from './components/image/image.component';
import {JsonItemComponent} from './components/json-item/json-item.component';
import {JsonListComponent} from './components/json-list/json-list.component';
import {JsonViewerComponent} from './components/json-viewer/json-viewer.component';
import {KeyboardComponent} from './components/keyboard/keyboard.component';
import {KnxComponent} from './components/knx/knx.component';
import {LabelQueueComponent} from './components/label-queue/label-queue.component';
import {LocationBaseComponent} from './components/location-base/location-base.component';
import {MessageComponent} from './components/message/message.component';
import {NumericStepperComponent} from './components/numeric-stepper/numeric-stepper.component';
import {PlaylistComponent} from './components/playlist/playlist.component';
import {PodcastComponent} from './components/podcast/podcast.component';
import {QrComponent} from './components/qr/qr.component';
import {RadioComponent} from './components/radio/radio.component';
import {RichTextComponent} from './components/rich-text/rich-text.component';
import {RssComponent} from './components/rss/rss.component';
import {SceneComponent} from './components/scene/scene.component';
import {SerialPortComponent} from './components/serial-port/serial-port.component';
import {StockItemComponent} from './components/stock-item/stock-item.component';
import {StockTickerComponent} from './components/stock-ticker/stock-ticker.component';
import {SwitchComponent} from './components/switch/switch.component';
import {VideoComponent} from './components/video/video.component';
import {XmlItemComponent} from './components/xml-item/xml-item.component';
import {XmlPlayerComponent} from './components/xml-player/xml-player.component';
import {YouTubeComponent} from './components/you-tube/you-tube.component';
import {QRCodeModule} from 'angularx-qrcode';
import {LoaderComponent} from "./components/Loader/loader.component";
import {NotSupportedComponent} from "./components/not-supported/not-supported.component";
import {MaterialModules} from "./common.modules";
import {SafeHtmlPipe} from "./components/html/SafeHtmlPipe";
import {FlickingComponent} from "./components/flicking/flicking.component";
import {NgxFlickingModule} from "@egjs/ngx-flicking";
import {FlickingItemComponent} from "./player/flicking-item.component";
import {PttMicComponent} from "./components/ptt/ptt-mic.component";
import {PttSpkComponent} from "./components/ptt/ptt-spk.component";
import {GpsComponent} from "./components/ptt/gps.component";
import {AyreshareComponent} from "./components/ayreshare/ayreshare.component";
import {CanvaComponent} from "./components/Canva/canva.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {DialogPopComponent} from "./dialog-pop/dialog-pop.component";
import {MusicComponent} from "./components/music/music.component";
import {MusicListComponent} from "./components/music-list/music-list.component";



@NgModule({
    declarations: [
      DialogPopComponent,
      NotSupportedComponent,
      AdNetComponent,
      ButtonComponent,
      PttMicComponent,
      PttSpkComponent,
      GpsComponent,
      CameraComponent,
      CartComponent,
      CatalogItemComponent,
      CatalogPlayerComponent,
      ChartComponent,
      CheckboxComponent,
      ClockComponent,
      CollectionComponent,
      CountdownComponent,
      CustomRssItemComponent,
      CustomRssPlayerComponent,
      ExtAppComponent,
      ExtImageComponent,
      ExtVideoComponent,
      FasterQComponent,
      FormComponent,
      HtmlComponent,
      CanvaComponent,
      ImageComponent,
      JsonItemComponent,
      JsonListComponent,
      JsonViewerComponent,
      AyreshareComponent,
      KeyboardComponent,
      KnxComponent,
      LabelComponent,
      LabelQueueComponent,
      LocationBaseComponent,
      MessageComponent,
      NumericStepperComponent,
      PlaylistComponent,
      MusicListComponent,
      MusicComponent,
      FlickingComponent,
      FlickingItemComponent,
      PodcastComponent,
      QrComponent,
      RadioComponent,
      RichTextComponent,
      RssComponent,
      SceneComponent,
      SerialPortComponent,
      SliderComponent,
      StockItemComponent,
      StockTickerComponent,
      SwitchComponent,
      TextInputComponent,
      VideoComponent,
      XmlItemComponent,
      XmlPlayerComponent,
      YouTubeComponent,
      LoaderComponent,
      SafeHtmlPipe
    ],
    imports: [
      CommonModule,
      QRCodeModule,
      MaterialModules,
      NgxFlickingModule
    ],
  exports: [
    MaterialModules,
    NgxFlickingModule
  ],
    providers: [
    ],
    bootstrap: []
})
export class SignageLibsModuleCommon { }
